
/**
 * This is used to zoom on product main Image
 *
 * @module utils/zoomUtils
 * @memberof -Common
 */

/**
 * It will find the position of mouse
 *
 * @method getCursorPos
 * @param {MouseEvent} e - Mouse event captured when mouse movement happens over image
 * @param {HTMLElement} img - This is the image component where the main product image is  present
 * @Returns {object} - Cursor position
 * @Returns {object.x} - Cursor x co-ordinate
 * @Returns {object.y} - Cursor y co-ordinate
 */
export const getCursorPos = ( e, img ) => {
  var a, x = 0, y = 0;
  var newE = e
  /* Get the x and y positions of the image: */
  a = img.getBoundingClientRect();
  /* Calculate the cursor's x and y coordinates, relative to the image: */
  x = newE.pageX - a.left;
  y = newE.pageY - a.top;
  /* Consider any page scrolling: */
  x = x - global.pageXOffset;
  y = y - global.pageYOffset;
  return { x: x, y: y };
}

/**
 * returns the measurements fo the zoom container
 * @param { HTMLElement } zoom_container - the zoom container
 * @param { HTMLElement } lens - the zoom lens container
 * @returns Object
 */
export const getZoomContainerMeasurements = ( zoom_container, lens ) => {
  let cx = zoom_container.offsetWidth / lens.offsetWidth;
  let cy = zoom_container.offsetWidth / lens.offsetWidth;
  return { cx, cy }
}

/**
 * gets the coordinates of the lens in coorelation to the mouse position on the image
 * @param { HTMLElement } image_container -html container for the image container
 * @param { HTMLElement } lens - HTML lens container
 * @returns Object
 */
export const getLensCoordinates = ( cursorPos, image_container, lens ) => {
  /* Calculate the position of the lens: */
  let x = cursorPos.x - ( lens.offsetWidth / 2 );
  let y = cursorPos.y - ( lens.offsetHeight / 2 );
  /* Prevent the lens from being positioned outside the image: */
  if( x > image_container.offsetWidth - lens.offsetWidth ){
    x = image_container.offsetWidth - lens.offsetWidth;
  }
  if( x < 0 ){
    x = 0;
  }

  if( y > image_container.offsetHeight - lens.offsetHeight ){
    y = image_container.offsetHeight - lens.offsetHeight;
  }
  if( y < 0 ){
    y = 0;
  }

  return { x, y }

}

/**
 * Add zoom to the image within same container on hover
 * @param {MouseEvent} e - Mouse event captured when mouse movement happens over image
 * @returns Object
 */

export const addZoomInContainer = ( e )=>{
  var zoomer = e.currentTarget;
  var nativeEvent = e.nativeEvent;
  var offsetX =  nativeEvent.offsetX ;
  var offsetY =  nativeEvent.offsetY ;
  var x = offsetX / zoomer.offsetWidth * 150;
  var y = offsetY / zoomer.offsetHeight * 150;
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
  return { x, y }
}
